/**
 * DR. ROSEY'S — THEME JS
 * Scroll reveal, sticky nav shadow, cart badge
 */

(function () {
  'use strict';

  // ── SCROLL REVEAL ──────────────────────────────────────────
  function initReveal() {
    const els = document.querySelectorAll('.dr-reveal');
    if (!els.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  // ── STICKY NAV SHADOW + HIDE ON SCROLL DOWN ────────────────
function initNavShadow() {
  var headerEl = document.querySelector('.dr-header');
  var header = document.querySelector('#header-group');
  if (!header || !headerEl) return;

  var lastScrollY = document.documentElement.scrollTop;

  function hideHeader() {
  var announcementBar = document.querySelector('.dr-announcement');
  var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  header.style.transform = 'translateY(-' + (headerEl.offsetHeight + announcementHeight) + 'px)';
}

function showHeader() {
  var announcementBar = document.querySelector('.dr-announcement');
  var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  
  if (document.documentElement.scrollTop <= announcementHeight) {
    header.style.transform = 'translateY(0)';
  } else {
    header.style.transform = 'translateY(-' + announcementHeight + 'px)';
  }
}

  document.addEventListener('scroll', function () {
    var currentScrollY = document.documentElement.scrollTop;

    if (currentScrollY > 10) {
      headerEl.classList.add('dr-header--scrolled');
    } else {
      headerEl.classList.remove('dr-header--scrolled');
    }

    if (currentScrollY > lastScrollY && currentScrollY > 68) {
  hideHeader();
} else if (currentScrollY < lastScrollY) {
  showHeader();
}

    lastScrollY = currentScrollY;
  }, { passive: true });
}

  // ── CART BADGE (AJAX) ──────────────────────────────────────
  function updateCartBadge(count) {
    var badges = document.querySelectorAll('.dr-cart-badge');
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // Expose for use in section JS
  window.DrRoseys = window.DrRoseys || {};
  window.DrRoseys.updateCartBadge = updateCartBadge;

  // ── AJAX ADD TO CART ───────────────────────────────────────
  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList.contains('dr-atc-form')) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Adding…';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartBadge(cart.item_count);
          btn.innerHTML = '✓ Added!';
          btn.style.background = 'var(--teal-dark)';
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        });
    });
  }

// ── MOBILE MENU ───────────────────────────────────────────
function initMobileMenu() {
  var hamburger = document.querySelector('.dr-hamburger');
  var mobileMenu = document.querySelector('.dr-mobile-menu');
  if (!hamburger || !mobileMenu) return;

  hamburger.addEventListener('click', function () {
    var isOpen = mobileMenu.classList.contains('is-open');
    mobileMenu.classList.toggle('is-open');
    hamburger.classList.toggle('is-open');
    hamburger.setAttribute('aria-expanded', !isOpen);
  });

  // Close when clicking a link
  mobileMenu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      mobileMenu.classList.remove('is-open');
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
    });
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (!hamburger.contains(e.target) && !mobileMenu.contains(e.target)) {
      mobileMenu.classList.remove('is-open');
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
    }
  });
}

  // ── INIT ───────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initNavShadow();
    initAjaxCart();
    initMobileMenu();
  });

})();